import { render, staticRenderFns } from "./gantt-pagination.vue?vue&type=template&id=3e15fafe&scoped=true&"
import script from "./gantt-pagination.component.ts?vue&type=script&lang=ts&"
export * from "./gantt-pagination.component.ts?vue&type=script&lang=ts&"
import style0 from "./gantt-pagination.scss?vue&type=style&index=0&id=3e15fafe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e15fafe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e15fafe')) {
      api.createRecord('3e15fafe', component.options)
    } else {
      api.reload('3e15fafe', component.options)
    }
    module.hot.accept("./gantt-pagination.vue?vue&type=template&id=3e15fafe&scoped=true&", function () {
      api.rerender('3e15fafe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-v2/components/gantt-pagination/gantt-pagination.vue"
export default component.exports